/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import api from "../../../services/api";
import { useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import SweetAlert from "sweetalert2";
import Content from "../../../components/Content";
import ContentHeader from "../../../components/ContentHeader";
import CustomModal from "../../../components/Modal";
import CardHeader from "../../../components/CardHeader";
import CardFooter from "../../../components/CardFooter";
import TableGrid from "../../../components/TableGrid";
import Button from "../../../components/Button";
import { toast } from "react-toastify";
import Select from "react-select";
import MUIDataTable from "mui-datatables";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { TabContext } from "@mui/lab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import _ from "lodash";
import Loading from "../../../components/Loading";

import { FaKey } from "react-icons/fa";
import { GrClearOption } from "react-icons/gr";
import { HiDocumentReport } from "react-icons/hi";

import { EditProvider } from "./Context";
import { validaCpf, formatTypeDocument } from "../../../util/rotinas";

import Representantes from "./Representantes";
import dayjs from "dayjs";
import ptBr from "dayjs/locale/pt-br";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
dayjs.locale(ptBr);
dayjs.extend(LocalizedFormat);

const ClienteNovo = (props) => {
  const history = useHistory();

  const isDesktop = useIsDesktop(800);

  const [novoCliente, setNovoCliente] = useState(undefined);
  const [dataAtual, setDataAtual] = useState(undefined);
  const [representatives, setRepresentatives] = useState([]);
  const [isEditClient, setIsEditClient] = useState(false);

  const [statementMateraByClient, setStatementMateraByClient] = useState([]);
  const [statementMateraByClientFiltered, setStatementMateraByClientFiltered] =
    useState([]);
  const [filterDateIni, setFilterDateIni] = useState(
    dayjs().subtract(15, "day").format("YYYY-MM-DD")
  );
  const [filterDateFim, setFilterDateFim] = useState(
    dayjs().format("YYYY-MM-DD")
  );

  //  MODALS
  const [modalPdvOpen, setModalPdvOpen] = useState(false);
  const modalPdvRef = useRef(null);
  const [modalStatementOpen, setModalStatementOpen] = useState(false);
  const modalStatementRef = useRef(null);
  const [modalKeysPixMatera, setModalKeysPixMatera] = useState(false);
  const modalRefKeysPixMatera = useRef(null);

  const [instituicoes, setInstituicoes] = useState([]);
  const [materaInfo, setMateraInfo] = useState([]);
  const [shipayInfo, setShipayInfo] = useState(undefined);
  const [isEditPdv, setIsEditPdv] = useState(false);
  const [idEditPdv, setIdEditPdv] = useState(false);
  const [value, setValue] = React.useState("1");

  //FORMS
  const [form, setForm] = useState({});
  const [formShipay, setFormShipay] = useState({});
  const [formMatera, setFormMatera] = useState({});
  const [formPdv, setFormPdv] = useState({});
  const [formDocument, setFormDocument] = useState({
    description: null,
  });

  //LOADINGS
  const [loading, setLoading] = useState(false);
  const [loadingModalStatement, setLoadingModalStatement] = useState(false);
  const [loadingInfoMatera, setLoadingInfoMatera] = useState(false);
  const [loadingAccountMatera, setLoadingAccountMatera] = useState(false);
  const [loadingKeysPix, setLoadingKeysPix] = useState(false);
  const [loadingInactiveAccount, setLoadingInactiveAccount] = useState(false);
  const [loadingDocuments, setLoadingDocuments] = useState(false);

  const [cities, setCities] = useState(undefined);
  const [UFs, setUFs] = useState(undefined);

  const [typeSelect, setTypeSelect] = useState({
    id: 1,
    name: "EVP",
  });

  const optionsTypes = [
    {
      id: 1,
      name: "EVP",
    },
  ];

  function handleForm(key, value) {
    setForm({
      ...form,
      [key]: value,
    });
  }

  function handleFormSendDocument(key, value) {
    setFormDocument({
      ...formDocument,
      [key]: value,
    });
  }

  function handleFormPdv(key, value) {
    setFormPdv({
      ...formPdv,
      [key]: value,
    });
  }

  function handleFormShipay(key, value) {
    setFormShipay({
      ...formShipay,
      [key]: value,
    });
  }

  const handleChangeFilterDate = function (e, errors, values) {
    if (errors.length === 0) {
      getStatementByMateraAccountId(formMatera[0].account_id);
    }
  };

  const handleChange = (event, newValue) => {
    if (newValue === "4") {
      handleGetInstituitions();
    }
    setValue(newValue);
  };

  const handleCloseModalPdv = () => {
    setModalPdvOpen(false);
    setIsEditPdv(false);
    setFormPdv({});
  };

  const handleCloseModalStatement = () => {
    setModalStatementOpen(false);
  };

  function formatData(data) {
    return data.split("T")[0];
  }

  const getClienteByPk = useCallback(() => {
    try {
      setLoading(true);
      api.get(`/customer/findByPk?id=${props.match.params.id}`).then((res) => {
        setNovoCliente(res.data.data);
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [props.match.params.id]);

  async function getCities(UF) {
    const request = await fetch(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/municipios`
    );
    const result = await request.json();
    setCities(result);
  }

  async function getUFS() {
    const request = await fetch(
      "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
    );
    const result = await request.json();
    setUFs(result);
  }

  function buildOptionsUF() {
    if (UFs) {
      return UFs.map((uf) => {
        return (
          <option key={uf.id} value={uf.sigla}>
            {uf.sigla}
          </option>
        );
      });
    }
  }

  const typeDocuments = [
    {
      value: null,
      label: "",
    },
    {
      value: "picture",
      label: "Representante - SELFIE",
    },
    {
      value: "identify_front",
      label: "Representante - RG (Frente)",
    },
    {
      value: "identify_back",
      label: "Representante - RG (Trás)",
    },
    {
      value: "cnh",
      label: "Representante - CNH",
    },
    {
      value: "social_contract",
      label: "Empresa - Contrato Social ",
    },
    {
      value: "power_of_attorney",
      label: "Empresa - Procuração ",
    },
    {
      value: "terms_of_use",
      label: "Empresa - Temos de uso FLAGSHIP ",
    },
  ];

  const [typeDocumentSelect, setTypeDocumentSelect] = useState({
    value: null,
    label: "",
  });

  function buildOptionsCities() {
    if (cities) {
      return cities.map((city) => {
        return (
          <option key={city.id} value={city.nome}>
            {city.nome}
          </option>
        );
      });
    }
  }

  function validate(params) {
    if (params === undefined || params === null || params.trim() === "") {
      return true;
    }
    return false;
  }

  function enablePIXAccountCreation(cli) {
    if (cli) {
      if (
        validate(cli.name) ||
        validate(cli.cpf_cnpj) ||
        validate(cli.phone) ||
        validate(cli.email) ||
        validate(cli.address) ||
        validate(cli.address_number) ||
        validate(cli.district) ||
        validate(cli.city) ||
        validate(cli.state) ||
        validate(cli.zip_code) ||
        validate(cli.date_foundation)
      ) {
        return false;
      }
    }
    return true;
  }

  const handleSubmit = function (e, errors) {
    e.preventDefault();
    if (errors && errors.length === 0) {
      try {
        setLoading(true);
        if (novoCliente === undefined) {
          api
            .post("/customer", {
              ...form,
              date_foundation: form.date_foundation + "T00:00:00.000Z",
              phone: form.phone ? form.phone.replace(/[^0-9]/g, "") : "",
            })
            .then((result) => {
              if (result.data.data.message) {
                toast.error(`${result.data.data.message}`, {
                  position: "bottom-center",
                  autoClose: true,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: 0,
                });
              } else {
                if (result.data.sucess === true) {
                  toast.success(`Novo Cliente incluido com sucesso.`, {
                    position: "bottom-center",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: 0,
                  });
                  history.push("/customer");
                } else {
                  toast.error(`Erro durante a criacao de nova publicidade.`, {
                    position: "bottom-center",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: 0,
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          let temp = form;
          delete temp["fortes_id"];
          delete temp["representatives"];
          delete temp["fees"];
          delete temp["keysPix"];
          delete temp["InstituitionCustomer"];

          api
            .put(`/customer`, {
              ...temp,
              date_foundation: temp.date_foundation + "T00:00:00.000Z",
              phone: form.phone ? form.phone.replace(/[^0-9]/g, "") : "",
            })
            .then((result) => {
              if (result.data.data.message) {
                toast.error(`${result.data.data.message}`, {
                  position: "bottom-center",
                  autoClose: true,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: 0,
                });
              } else {
                if (result.data.sucess === true) {
                  toast.success(`Cadastro atualizado com sucesso.`, {
                    position: "bottom-center",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: 0,
                  });
                  getClienteByPk();
                } else {
                  toast.error(`Erro ao atualizar cadastro do cliente.`, {
                    position: "bottom-center",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: 0,
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error(`O(s) campos | ${errors} | não podem ser vazios `, {
        position: "bottom-center",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: 0,
      });
    }
  };

  function createContaMatera() {
    let data = {
      cnpj: form.cpf_cnpj,
    };
    setLoadingInfoMatera(true);
    api
      .post(`/matera/create-account`, data)
      .then((res) => {
        toast.success(`Solicitação de conta efetuada`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
        setTimeout(async () => {
          setLoadingInfoMatera(false);
          getClienteByPk();
        }, 4500);
      })
      .catch((err) => {
        setLoadingInfoMatera(false);
        console.log(err);
      });
  }
  function revalidateAccountMatera() {
    let data = {
      cnpj: form.cpf_cnpj,
      matera_account_id: formMatera[0].account_id,
    };
    setLoadingInfoMatera(true);
    api
      .post(`/matera/revalidate-account`, data)
      .then((res) => {
        toast.success(`Solicitação de conta efetuada`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
        setTimeout(async () => {
          setLoadingInfoMatera(false);
          getClienteByPk();
        }, 4500);
      })
      .catch((err) => {
        setLoadingInfoMatera(false);
        console.log(err);
      });
  }

  const handleSubmitKeyPix = function (e, errors, values) {
    e.preventDefault();
    if (errors.length === 0) {
      try {
        setLoadingKeysPix(true);
        let data = {
          cnpj: form["cpf_cnpj"],
          type: typeSelect.name,
        };
        api.post(`/matera/create-key-pix`, data).then((res) => {
          if (res.data.sucess === true) {
            toast.success(`Chave PIX Adicionada`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
          }
          if (res.data.data.error) {
            toast.error(`${res.data.data.error.description}`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
          }
          setTimeout(() => {
            window.location.reload();
          }, 4500);
        });
      } catch (err) {
        console.log(err);
        setLoadingKeysPix(false);
      } finally {
        setLoading(false);
      }
    }
  };

  function handleAccountInactive(e, row) {
    setLoadingInactiveAccount(true);
    e.preventDefault();
    SweetAlert.fire({
      title: "Atenção",
      text: `Tem certeza que deseja INATIVAR esta conta?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .post("/matera/make-account-inactive", {
            account_id: row.account_id,
            instituition_costumer_id: row.instituition_costumer_id,
          })
          .then((res) => {
            toast.success(`Conta inativada com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            getInstituicoes();
            setLoadingInactiveAccount(false);
          })
          .catch(() => {
            setLoadingInactiveAccount(false);
          });
      } else {
        setLoadingInactiveAccount(false);
      }
    });
  }

  function handleDeletePdv(e, row) {
    e.preventDefault();
    SweetAlert.fire({
      title: "Confirma exclusão deste PDV ? ",
      text: ``,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete("/pdv/" + row.id)
          .then((res) => {
            toast.success(`PDV Deletado.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            getInstituicoes();
          })
          .catch((err) => {
            toast.error(`Erro ao Deletar PDV`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
          });
      }
    });
  }

  function handleEditPdv(e, row) {
    setModalPdvOpen(true);
    setIsEditPdv(true);
    setIdEditPdv(row.id);
    setFormPdv(row);
  }

  const handleSubmitPdv = function (e, errors, values) {
    e.preventDefault();
    let id = undefined;
    if (values === "SHIPAY") {
      id = formShipay.id;
    }
    if (values === "MATERA") {
      id = formMatera.id;
    }
    if (errors.length === 0) {
      try {
        setLoading(true);
        let data = {
          ...formPdv,
        };
        if (isEditPdv === false) {
          data.instituition_costumer_id = id;
          data.cnpj = novoCliente.cpf_cnpj;
          api
            .post("/pdv", data)
            .then((res) => {
              toast.success(`PDV Adicionado.`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              });
              setModalPdvOpen(false);
              setFormPdv({});
              getInstituicoes();
            })
            .catch((err) => {
              console.log(err);
              toast.error(`Erro ao adicionar PDV`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              });
            });
        } else {
          data.id = idEditPdv;
          api
            .put("/pdv", data)
            .then((res) => {
              toast.success(`PDV Atualizado.`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              });
              setModalPdvOpen(false);
              getInstituicoes();
              setFormPdv({});
            })
            .catch((err) => {
              console.log(err);
              toast.error(`Erro ao atualizar PDV`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              });
            });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error(`O(s) campos | ${errors} | não podem ser vazios`, {
        position: "bottom-center",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: 0,
      });
    }
  };

  function deleteChavePix(e, row) {
    e.preventDefault();
    const data = {
      cnpj: novoCliente.cpf_cnpj,
      matera_account_id: formMatera[0].account_id,
      alias: row.key,
    };
    SweetAlert.fire({
      title: "Confirma exclusão da chave ? ",
      text: `${row.key} `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoadingKeysPix(true);
        api
          .post("/matera/delete-aliases", data)
          .then((res) => {
            toast.success(`Chave PIX deletada com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            setTimeout(() => {
              setLoadingKeysPix(false);
              handleCloseModalKeysPixMatera(false);
              window.location.reload();
            }, 4500);
          })
          .catch((err) => {
            setLoadingKeysPix(false);
            console.log(err);
          });
      }
    });
  }

  const validateCPF = (value, ctx, input, cb) => {
    let temp = "";
    if (form["cpf_cnpj"] !== undefined) {
      temp = form["cpf_cnpj"];
    }
    cb(validaCpf(temp));
  };

  function reloadStatusAccount() {
    setLoadingAccountMatera(true);
    api
      .get("/matera/reload-status")
      .then((res) => {
        setTimeout(() => {
          getInstituicoes();
          setLoadingAccountMatera(false);
          // window.location.reload()
        }, 4500);
      })
      .catch((err) => {
        console.log(err);
        setLoadingAccountMatera(false);
      });
  }

  function verifyStatusAccountMatera(status) {
    if (status === "CREATING") {
      return (
        <div className="btn-group btn-group-xs pull-left">
          <Button
            type="submit"
            className="left"
            title="CREATING"
            disabled={false}
            loading={loadingInfoMatera}
            onClick={() => reloadStatusAccount()}
          />
          {/* <button
          className='btn btn-primary btn-sm'
          onClick={() => reloadStatusAccount()}
          style={{ width: '120px', padding: '8px', borderRadius: '8px' }}
        >
          {!loadingAccountMatera ? <span>CREATING</span> : <Loading loading={loadingAccountMatera} size={12} color={'white'} />}
        </button> */}
        </div>
      );
    } else if (status === "REGULAR") {
      return (
        <div className="btn-group btn-group-xs pull-left">
          <button
            className="btn-success btn-sm disabled "
            style={{ width: "120px", padding: "8px", borderRadius: "8px" }}
          >
            REGULAR
          </button>
        </div>
      );
    } else if (status === "CLOSED") {
      return (
        <div className="btn-group btn-group-xs pull-left">
          <button
            className="btn btn-secondary btn-sm disabled "
            style={{ width: "120px", padding: "8px", borderRadius: "8px" }}
          >
            FECHADA
          </button>
        </div>
      );
    } else if (status === "ERROR" || status === "REJECTED") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button
            className="btn-danger btn-sm "
            style={{ width: "120px", padding: "8px", borderRadius: "8px" }}
          // onClick={() => reloadStatusAccount()}
          >
            {status}
          </button>
        </div>
      );
    }
  }

  function handleCloseModalKeysPixMatera() {
    setModalKeysPixMatera(false);
  }

  function showModalCreateKeyPix(e, row) {
    setModalKeysPixMatera(true);
  }
  function showModalStatement(e, row) {
    e.preventDefault();
    setModalStatementOpen(true);
    getStatementByMateraAccountId(row.account_id);
  }

  function handleTransactionType(transactionType) {
    if (transactionType === "PAYMENTINSTANTPAYMENT") {
      return "RECEBIMENTO VIA QR-CODE";
    } else if (transactionType === "DEPOSITINSTANTPAYMENT") {
      return " RECEBIMENTO VIA CHAVE";
    } else if (transactionType === "WITHDRAWRETURNINSTANTPAYMENT") {
      return "DEVOLUÇÃO";
    } else if (transactionType === "WITHDRAWINSTANTPAYMENT") {
      return "RETIRADA CASHOUT";
    } else {
      return transactionType;
    }
  }

  function getStatementByMateraAccountId(account_id) {
    setLoadingModalStatement(true);
    try {
      api
        .get(
          `/matera/get-statement-by-account-id?accountId=${account_id}&ending=${filterDateFim}&start=${filterDateIni}`
        )
        .then((res) => {
          const data = res?.data?.data.map((item) => {
            if (item.type === "C") {
              return item;
            } else {
              return {
                ...item,
                amount: item.amount * -1,
              };
            }
          });

          let grouped_data = Object.values(
            _.groupBy(data, (item) => item.transactionId)
          ).map((item) => {
            if (item.length === 2) {
              if (item[0].type === "C") {
                return {
                  ...item[0],
                  credito: item[0].amount,
                  taxa: item[1].amount,
                  transactionType: handleTransactionType(
                    item[0].transactionType
                  ),
                  saldo: item[0].amount + item[1].amount,
                };
              } else if (item[1].type === "C") {
                return {
                  ...item[0],
                  credito: item[1].amount,
                  taxa: item[0].amount,
                  transactionType: handleTransactionType(
                    item[0].transactionType
                  ),
                  saldo: item[0].amount + item[1].amount,
                };
              } else {
                return {
                  ...item[0],
                  debito: item[0].amount,
                  taxa: item[1].amount,
                  transactionType: handleTransactionType(
                    item[0].transactionType
                  ),
                  saldo: item[0].amount + item[1].amount,
                };
              }
            } else {
              return {
                ...item[0],
                transactionType: handleTransactionType(item[0].transactionType),
              };
            }
          });
          let grouped_dataSorted = grouped_data.sort(
            (a, b) => new Date(b.entryDate) - new Date(a.entryDate)
          );
          setStatementMateraByClient(grouped_dataSorted);
          setStatementMateraByClientFiltered(grouped_dataSorted);
          setLoadingModalStatement(false);
        });
    } catch (err) {
      setLoadingModalStatement(false);
      console.log(err);
    }
  }

  //COLUMNS

  const columnsPdvShipay = useMemo(() => [
    {
      name: "Descrição",
      selector: "name",
    },
    {
      name: "Chave",
      selector: "key_pdv",
      width: "270px",
    },
    {
      name: "Id Externo",
      selector: "account_id",
      width: "900px",
    },
    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          <>
            <button
              className="btn btn-default btn-xs"
              onClick={(e) => handleEditPdv(e, row)}
            >
              <i className="fa fa-fw fa-pencil"></i>
            </button>
          </>
          <>
            <button
              onClick={(e) => handleDeletePdv(e, row)}
              className="btn btn-danger btn-xs"
            >
              <i className="fa fa-fw fa-trash-o"></i>
            </button>
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  const columnsPdvMatera = useMemo(() => [
    // {
    //   name: 'Descrição',
    //   selector: 'name',
    //   width: '120px'
    // },
    {
      name: "Chave",
      selector: "key_pdv",
      width: "270px",
    },
    {
      name: "Id Externo",
      selector: "account_id",
    },
    {
      name: "Saldo",
      selector: (row) =>
        row.saldo ? formatNumber(row.saldo) : formatNumber(0),
      width: "140px",
    },
    {
      name: "Status",
      selector: (row) => verifyStatusAccountMatera(row.account_status),
      width: "152px",
    },
    {
      width: "50px",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-left">
          <>
            {formMatera[0].account_status === "REGULAR" ? (
              <button
                className="btn btn-primary btn-sm"
                onClick={(e) => showModalCreateKeyPix(e, row)}
                style={{ padding: "8px", borderRadius: "8px" }}
              >
                <FaKey />
              </button>
            ) : (
              <></>
            )}
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      width: "50px",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-left">
          <>
            {formMatera[0].account_status === "REGULAR" ? (
              <button
                className="btn btn-primary btn-xs"
                onClick={(e) => showModalStatement(e, row)}
                style={{ padding: "8px", borderRadius: "8px" }}
              >
                <HiDocumentReport />
              </button>
            ) : (
              <></>
            )}
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      width: "130px",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-left">
          <>
            {formMatera[0].account_status === "REGULAR" ? (
              <button
                className="btn btn-danger btn-sm"
                onClick={(e) => handleAccountInactive(e, row)}
                style={{ width: "120px", padding: "8px", borderRadius: "8px" }}
              >
                {!loadingInactiveAccount ? (
                  <span>INATIVAR</span>
                ) : (
                  <Loading
                    loading={loadingInactiveAccount}
                    size={12}
                    color={"black"}
                  />
                )}
              </button>
            ) : (
              <></>
            )}
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  const columnsKeyPix = useMemo(() => [
    {
      name: "Chave PIX",
      selector: "key",
      width: "400px",
      sortable: true,
    },
    {
      name: "Tipo",
      selector: "type",
      width: "100px",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      width: "100px",
      sortable: true,
    },
    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          <>
            <button
              onClick={(e) => deleteChavePix(e, row)}
              className="btn btn-danger btn-xs"
            >
              <i className="fa fa-fw fa-trash-o"></i>
            </button>
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  const columnsMoviments = [
    {
      name: "entryDate",
      label: "DATA",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {dayjs(value).format("lll")}
            </div>
          );
        },
      },
    },

    {
      name: "transactionType",
      label: "TIPO",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "credito",
      label: "CRÉDITO",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {value ? formatNumber(Number(value)) : formatNumber(0)}
            </div>
          );
        },
      },
    },
    {
      name: "debito",
      label: "DÉBITO",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {value ? formatNumber(Number(value)) : formatNumber(0)}
            </div>
          );
        },
      },
    },
    {
      name: "taxa",
      label: "TAXA",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {formatNumber(Number(value))}
            </div>
          );
        },
      },
    },

    {
      name: "saldo",
      label: "VALOR LÍQUIDO",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {value > 0 ? (
                <span style={{ color: "green" }}>
                  {formatNumber(Number(value))}
                </span>
              ) : (
                <span style={{ color: "red" }}>
                  {formatNumber(Number(value))}
                </span>
              )}
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filter: true,
    search: false,
    viewColumns: false,
    download: false,
    print: true,
    rowsPerPage: 10,
    rowsPerPageOptions: [5],
    tableBodyMaxHeight: "400px",
    tableHeadHeight: "200px",
    textLabels: {
      body: {
        noMatch: "Nenhum registro encontrado",
        toolTip: "Classificar",
      },
      pagination: {
        next: "Próxima página",
        previous: "Página anterior",
        rowsPerPage: "Por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Busca",
        downloadCsv: "Download CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar Tabelas",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "LIMPAR",
      },
      viewColumns: {
        title: "Ver Colunas",
        titleAria: "Ver/Esconder Colunas da Tabela",
      },
      selectedRows: {
        text: "registros(s) selecionados",
        delete: "Excluir",
        deleteAria: "Excluir registros selecionados",
      },
    },
  };

  function formatNumber(n) {
    return n.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
  }

  const [showTabShipay, setShowTabShipay] = useState(false);
  const [showTabMatera, setShowTabMatera] = useState(false);

  async function getAllInstituitions() {
    await api
      .get(`instituition`)
      .then((res) => {
        const temp = res.data.data;
        let shipayTab = temp.filter((item) => item.name === "SHIPAY_ITAU");
        if (shipayTab.length > 0) {
          if (shipayTab[0].active === true) {
            setShowTabShipay(true);
          }
        }
        let materaTab = temp.filter((item) => item.name === "MATERA");
        if (materaTab.length > 0) {
          if (materaTab[0].active === true) {
            setShowTabMatera(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getInstituicoes() {
    let temp = {
      id_customer: novoCliente.id,
      id_instituition: 0,
    };
    api
      .post(`/customer/getInstitutions`, temp)
      .then((res) => {
        setInstituicoes(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleAddInstituitionCustomer(idInstituition) {
    api
      .post("/customer/institutions", {
        customer_id: novoCliente.id,
        instituition_id: idInstituition,
        account_status: "",
        access_key: "",
        secret_key: "",
      })
      .then((res) => {
        getInstituicoes();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleEditAccountShipay() {
    let temp = formShipay;
    delete temp["pdvs"];
    api
      .put("/customer/institutions", temp)
      .then((res) => {
        toast.success(`Sucesso.`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
        getInstituicoes();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handlePhone(args) {
    args = args.replace(/\D/g, "");
    args = args.replace(/(\d{2})(\d)/, "($1) $2");
    args = args.replace(/(\d)(\d{4})$/, "$1-$2");
    return args;
  }

  useEffect(() => {
    if (dataAtual === undefined) {
      let data = new Date();
      let dia = String(data.getDate()).padStart(2, "0");
      let mes = String(data.getMonth() + 1).padStart(2, "0");
      let ano = data.getFullYear();
      let dataAtual = ano + "-" + mes + "-" + dia;
      setDataAtual(dataAtual);
    }
  }, [dataAtual]);

  useEffect(() => {
    if (props.match.params.id) {
      getClienteByPk();
      getAllInstituitions();
    }
    return () => { };
  }, [getClienteByPk, props.match.params.id]);

  useEffect(() => {
    if (novoCliente !== undefined) {
      if (novoCliente.date_foundation) {
        novoCliente.date_foundation = formatData(novoCliente.date_foundation);
      }
      getInstituicoes();
      setForm(novoCliente);
      setIsEditClient(true);
      setRepresentatives(novoCliente.representatives);
      getDocuments();
    } else {
      setIsEditClient(false);
    }
    return () => { };
  }, [novoCliente]);

  useEffect(() => {
    if (form && !form.hasOwnProperty("active")) {
      handleForm("active", false);
    }
    if (form && !form.hasOwnProperty("date_foundation")) {
      handleForm("date_foundation", dataAtual);
    }
    return () => { };
  }, [dataAtual, form, handleForm]);

  useEffect(() => {
    if (UFs === undefined) {
      getUFS();
    }
    return () => { };
  }, [getUFS]);

  useEffect(() => {
    if (form && form["state"] !== undefined) {
      getCities(form["state"]);
    }
    return () => { };
  }, [form["state"]]);

  async function handleGetInstituitions() {
    setLoadingInfoMatera(true);
    if (instituicoes.length > 0) {
      let tempMatera = instituicoes
        .filter((i) => i.instituition_id === 1)
        .filter(
          (item) =>
            item.account_status === "REGULAR" ||
            item.account_status === "CREATING"
        )
        .map((item) => {
          let obj = item.pdvs[0];
          obj.account_status = item.account_status;
          return obj;
        });
      // SE NÃO TIVER CONTA COM STATUS REGULAR VERIFICAR SE POSSUI ALGUMA COM STATUS ERRO PARA INFORMAR
      if (tempMatera.length === 0) {
        tempMatera = instituicoes
          .filter((i) => i.instituition_id === 1)
          .filter((item) => item.account_status === "CLOSED")
          .map((item) => {
            let obj = item.pdvs[0];
            obj.account_status = item.account_status;
            return obj;
          });
      }
      if (tempMatera.length === 0) {
        tempMatera = instituicoes
          .filter((i) => i.instituition_id === 1)
          .filter(
            (item) =>
              item.account_status === "ERROR" ||
              item.account_status === "REJECTED"
          )
          .map((item) => {
            let obj = item.pdvs[0];
            obj.account_status = item.account_status;
            return obj;
          });
      }
      let tt = [];
      tempMatera.forEach(async (account) => {
        let tempAccount = account;
        const data = await api.get(
          `/matera/get-balance-by-account-id?accountId=${account.account_id}`
        );
        const accountGetBalance = await Promise.resolve(data);
        tempAccount.saldo = accountGetBalance.data.data.real
          ? accountGetBalance.data.data.real
          : 0;
        tt.push(tempAccount);
        setMateraInfo(tt);
        setFormMatera(tt);
      });

      let tempShipay = instituicoes.filter((i) => i.instituition_id === 2);
      setShipayInfo(tempShipay[0]);
      setFormShipay(tempShipay[0]);
    }
    const timer = setTimeout(() => {
      setLoadingInfoMatera(false);
    }, 3000);

    return () => {
      clearInterval(timer);
    };
  }

  useEffect(() => {
    handleGetInstituitions();
    return () => { };
  }, [instituicoes]);

  function calcularDataMaxima(dataFinal) {
    return dayjs(dataFinal).subtract(30, "day").format("YYYY-MM-DD");
  }

  function calcularDataMinima(dataInicial) {
    const today = dayjs().toDate();
    const possibleDateMinima = dayjs(dataInicial).add(30, "day").toDate();
    return possibleDateMinima > today
      ? dayjs(today).format("YYYY-MM-DD")
      : dayjs(possibleDateMinima).format("YYYY-MM-DD");
  }

  const handleDataInicialChange = (event) => {
    setFilterDateIni(event.target.value);
  };

  const handleDataFinalChange = (event) => {
    setFilterDateFim(event.target.value);
  };

  const [selectedFile, setSelectedFile] = useState("");
  const [selectedFileUpload, setSelectedFileUpload] = useState(null);
  const [documents, setDocuments] = useState([]);

  const handleSubmitDocument = function (e, errors, values) {
    e.preventDefault();
    if (errors.length === 0) {
      try {
        setLoadingDocuments(true);
        setLoading(true);
        var formData = new FormData();
        formData.append("pdfFile", selectedFileUpload);
        formData.append("description", typeDocumentSelect.value);
        formData.append("customer_id", novoCliente.id);
        api
          .post(`/documents`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            toast.success(`Documento enviado com sucesso`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            handleClearClick();
            setFormDocument({});
            setTimeout(() => {
              setLoadingDocuments(false);
              getDocuments();
            }, 4500);
          });
      } catch (err) {
        toast.error(`Erro durante a upload do documento`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
        setLoadingDocuments(false);
      } finally {
        setLoading(false);
      }
    } else {
      errors.map((e) => {
        return toast.error(`Campo ${e} obrigatório`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        });
      });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(event.target.value);
    setSelectedFileUpload(file);
  };

  const handleClearClick = () => {
    setSelectedFile("");
    setSelectedFileUpload(null);
    setTypeDocumentSelect({
      value: null,
      label: "",
    });
  };

  async function downloadDocument(row) {
    const extension = row.url.split(".")[row.url.split(".").length - 1];
    await api
      .get(`/documents/download?id=${row.id}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${row.description}.${extension}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
  async function deleteDocument(row) {
    // setLoadingDocuments(true)
    SweetAlert.fire({
      title: "Atenção",
      text: `Tem certeza que deseja deletar este documento?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingDocuments(true);
        await api.delete(`/documents/${row.id}`).then((response) => {
          toast.success(`Documento deletado com sucesso`, {
            position: "bottom-center",
            autoClose: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
          });
          setTimeout(() => {
            setLoadingDocuments(false);
            getDocuments();
          }, 4500);
        });
      }
    });
  }

  // formatTypeDocument
  const columnsDocuments = useMemo(() => [
    {
      name: "Tipo",
      selector: "description",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          <span>{formatTypeDocument(row.description)}</span>
        </div>
      ),
      sortable: true,
    },
    {
      width: "100px",
      name: "Download",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          <>
            <button
              type="button"
              className="btn btn-default btn-xs"
              onClick={() => downloadDocument(row)}
            >
              <i className="fa fa-fw fa-eye"></i>
            </button>
          </>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      width: "100px",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          <button
            type="button"
            onClick={() => deleteDocument(row)}
            className="btn btn-danger btn-xs"
          >
            <i className="fa fa-fw fa-trash-o"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  const [flagDocuments, setFlagDocuments] = useState(false);
  useEffect(() => {
    console.log("FLG", flagDocuments);
  }, [flagDocuments]);

  async function getDocuments() {
    await api
      .get(`documents/findByCustomer?customer_id=${props.match.params.id}`)
      .then((res) => {
        // PARA VERIFICAR SE TODOS OS DOCUMENTOS JÁ FORAM UPADOS, ATRIBUIR UM PONTO PARA CADA DOCUMENTO,
        // O DOCUMENTO CNH SOMA  2 PONTOS, PORQUE ELE PODE SER ENVIADO SO UMA FOTO AO CONTRÁRIO DO RG QUE PRECISA SER FRENTE E VERSO
        const documentsTemp = res.data.data;
        const documentsCustomerTemp = documentsTemp.filter(
          (item) =>
            item.description === "social_contract" ||
            item.description === "power_of_attorney"
        );
        let sumQtdDocumentsCustomer = documentsCustomerTemp.length;

        let sumQtdDocumentsRepresentatives = 0;
        let documentsDefault = [
          "picture",
          "cnh",
          "identify_back",
          "identify_front",
        ];
        const documentsRepresentativesTemp = documentsTemp.filter((item) =>
          documentsDefault.includes(item.description)
        );

        documentsRepresentativesTemp.forEach((item) => {
          if (item.description === "cnh") {
            sumQtdDocumentsRepresentatives += 2;
          } else {
            sumQtdDocumentsRepresentatives += 1;
          }
        });
        console.log(sumQtdDocumentsCustomer, sumQtdDocumentsRepresentatives);
        if (
          sumQtdDocumentsCustomer === 2 &&
          sumQtdDocumentsRepresentatives >= 3
        ) {
          setFlagDocuments(false);
        } else {
          setFlagDocuments(true);
        }
        setDocuments(documentsTemp);
      });
  }

  return (
    <>
      <EditProvider>
        <ContentHeader
          urlPrevious="/"
          previousTitle="Pagina Inicial"
          smallTitle="Clientes"
        />
        <Content>
          <CardHeader
            title={"Clientes"}
            icon={"fa-unlock-alt"}
            searchVisible={false}
          />
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="Informações Gerais" value="1" />
                  {novoCliente !== undefined && (
                    <Tab label="Representantes" value="2" />
                  )}
                  {showTabShipay === true && novoCliente !== undefined && (
                    <Tab label="Shipay/Itau" value="3" />
                  )}
                  {showTabMatera === true && novoCliente !== undefined && (
                    <Tab label="Matera" value="4" />
                  )}
                  {novoCliente !== undefined && (
                    <Tab label="Documentos" value="5" />
                  )}
                </TabList>
              </Box>
              <TabPanel value="1">
                <div className="box">
                  <AvForm onSubmit={handleSubmit}>
                    <div
                      className="row"
                      style={{ padding: "10px 10px 0px 10px" }}
                    >
                      {props.match.params.id ? (
                        <div className="col-md-2">
                          <div className="form-group">
                            <AvField
                              type="text"
                              name="cpf_cnpj"
                              label="CPF/CNPJ *"
                              placeholder="CPF/CNPJ"
                              value={form["cpf_cnpj"] ? form["cpf_cnpj"] : ""}
                              required
                              disabled
                              onInput={(e) =>
                                handleForm("cpf_cnpj", e.target.value)
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-2">
                          <div className="form-group">
                            <AvField
                              type="text"
                              name="cpf_cnpj"
                              label="CPF"
                              placeholder="CPF"
                              pattern="^[0-9]*$"
                              value={form["cpf_cnpj"] ? form["cpf_cnpj"] : ""}
                              onInput={(e) =>
                                handleForm("cpf_cnpj", e.target.value)
                              }
                              validate={{ validateCPF }}
                              errorMessage="A string inserida não corresponde a um CPF válido."
                              required
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="cpf_cnpj_payer"
                            label="Cnpj Pagador"
                            placeholder="Cnpj Pagador"
                            value={
                              form["cpf_cnpj_payer"]
                                ? form["cpf_cnpj_payer"]
                                : ""
                            }
                            onInput={(e) =>
                              handleForm("cpf_cnpj_payer", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="Razao Social "
                            label="Razao Social *"
                            placeholder="Razão Social"
                            value={form["name"] ? form["name"] : ""}
                            required
                            onInput={(e) => handleForm("name", e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="fantasy_name"
                            label="Nome Fantasia *"
                            placeholder="Nome Fantasia"
                            value={
                              form["fantasy_name"] ? form["fantasy_name"] : ""
                            }
                            required
                            onInput={(e) =>
                              handleForm("fantasy_name", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-1">
                        <div className="form-group">
                          <AvField
                            type="select"
                            name="state"
                            label="UF *"
                            placeholder="UF"
                            value={form["state"] ? form["state"] : ""}
                            onChange={(event) =>
                              handleForm("state", event.target.value)
                            }
                          >
                            <option value={null}>-</option>
                            {buildOptionsUF()}
                          </AvField>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="select"
                            name="state"
                            label="Cidade *"
                            placeholder="Cidade"
                            value={form["city"] ? form["city"] : ""}
                            onChange={(event) =>
                              handleForm("city", event.target.value)
                            }
                          >
                            <option value={null}>-</option>
                            {buildOptionsCities()}
                          </AvField>
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="district "
                            label="Bairro *"
                            placeholder="Bairro"
                            value={form["district"] ? form["district"] : ""}
                            onInput={(e) =>
                              handleForm("district", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="address"
                            label="Logradouro *"
                            placeholder="Logradouro"
                            value={form["address"] ? form["address"] : ""}
                            onInput={(e) =>
                              handleForm("address", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="form-group">
                          <AvField
                            type="number"
                            name="address_number"
                            label="Nº *"
                            placeholder="Numero"
                            value={
                              form["address_number"]
                                ? form["address_number"]
                                : ""
                            }
                            min={0}
                            onInput={(e) =>
                              handleForm("address_number", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="zip_code"
                            label="CEP *"
                            placeholder="CEP"
                            value={form["zip_code"] ? form["zip_code"] : ""}
                            onInput={(e) =>
                              handleForm("zip_code", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="text"
                            name="phone"
                            label="Telefone Contato *"
                            placeholder="Telefone"
                            maxLength={15}
                            minLength={15}
                            value={
                              form["phone"] ? handlePhone(form["phone"]) : ""
                            }
                            onInput={(e) => handleForm("phone", e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <AvField
                            type="email"
                            name="email"
                            label="Email *"
                            placeholder="Email"
                            value={form["email"] ? form["email"] : ""}
                            onInput={(e) => handleForm("email", e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="date"
                            name="date_foundation"
                            label="Data de abertura *"
                            placeholder="Data de abertura"
                            value={
                              form["date_foundation"]
                                ? formatData(form["date_foundation"])
                                : ""
                            }
                            onInput={(e) =>
                              handleForm("date_foundation", e.target.value)
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <AvField
                            type="number"
                            name="qtd_licence"
                            label="Qtd Licença"
                            placeholder="Qtd Licença"
                            value={
                              form["qtd_licence"] ? form["qtd_licence"] : ""
                            }
                            min={0}
                            onInput={(e) =>
                              handleForm("qtd_licence", +e.target.value)
                            }
                          />
                        </div>
                      </div>

                      {props.match.params.id ? (
                        <div className="col-md-2">
                          <div className="form-group">
                            <AvField
                              type="text"
                              name="fortes_id"
                              label="Id do Fortes"
                              placeholder="Id do Fortes"
                              value={form["fortes_id"] ? form["fortes_id"] : ""}
                              min={0}
                              disabled
                              onInput={(e) =>
                                handleForm("fortes_id", +e.target.value)
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-2">
                          <div className="form-group">
                            <AvField
                              type="number"
                              name="fortes_id"
                              label="Id do Fortes"
                              placeholder="Id do Fortes"
                              value={form["fortes_id"] ? form["fortes_id"] : ""}
                              min={0}
                              onInput={(e) =>
                                handleForm("fortes_id", +e.target.value)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="row"
                      style={{ padding: "0px 10px 10px 10px" }}
                    >
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={form["active"] || false}
                            onChange={() =>
                              handleForm("active", !form["active"])
                            }
                          />
                          <label className="form-check-label">Ativo?</label>
                        </div>
                      </div>
                    </div>

                    <CardFooter loading={loading}>
                      <Button
                        type="submit"
                        title="Salvar"
                        disabled={false}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        title="Cancelar"
                        isCanceled
                        loading={loading}
                        onClick={() => history.push("/customer")}
                      />
                    </CardFooter>
                  </AvForm>
                </div>
              </TabPanel>
              <TabPanel value="2">
                {representatives && representatives.length > 0 ? (
                  <Content>
                    <Representantes
                      materaId={form["matera_account_id"]}
                      representantes={representatives}
                    />
                  </Content>
                ) : isEditClient ? (
                  <Content>
                    <Representantes
                      materaId={form["matera_account_id"]}
                      representantes={[]}
                    />
                  </Content>
                ) : (
                  <></>
                )}
              </TabPanel>
              <TabPanel value="3">
                {shipayInfo === undefined || shipayInfo.length === 0 ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>Cliente nao possui vinculo com a SHIPAY</span>
                    <div>
                      <Button
                        type="button"
                        title="Criar associação com a SHIPAY"
                        onClick={() => handleAddInstituitionCustomer(2)}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <AvForm onSubmit={handleEditAccountShipay}>
                      <div
                        className="row"
                        style={{ padding: "10px 10px 0px 10px" }}
                      >
                        <div className="col-md-12">
                          <div className="form-group">
                            <AvField
                              type="text"
                              name="secret_key"
                              label="Chave Secreta Shipay"
                              placeholder="Chave Secreta Shipay"
                              value={
                                formShipay["secret_key"]
                                  ? formShipay["secret_key"]
                                  : ""
                              }
                              onInput={(e) =>
                                handleFormShipay("secret_key", e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <AvField
                              type="text"
                              name="access_key"
                              label="Chave de Acesso Shipay"
                              placeholder="Chave de Acesso Shipay "
                              value={
                                formShipay["access_key"]
                                  ? formShipay["access_key"]
                                  : ""
                              }
                              onInput={(e) =>
                                handleFormShipay("access_key", e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <CardFooter loading={loading}>
                        <Button
                          type="submit"
                          title="Salvar"
                          disabled={false}
                          loading={loading}
                        />
                      </CardFooter>
                    </AvForm>
                    <div>
                      <Content>
                        <CardHeader title={"PDVs"} icon={"fa-university"} />
                        <div>
                          <TableGrid
                            columns={columnsPdvShipay}
                            data={formShipay.pdvs}
                            paginationPerPage={5}
                            loading={loading}
                          />
                        </div>
                        <CardFooter loading={loading}>
                          <Button
                            type="button"
                            title="Adicionar PDV"
                            onClick={() => setModalPdvOpen(true)}
                          />
                        </CardFooter>
                      </Content>
                    </div>
                  </>
                )}
              </TabPanel>
              <TabPanel value="4">
                {materaInfo.length === 0 ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {novoCliente !== undefined &&
                      novoCliente.representatives &&
                      novoCliente.representatives.length === 0 ? (
                      <span>
                        * Necessário cadastrar 1 (um) representante antes de
                        solicitar a abertura de conta MATERA
                      </span>
                    ) : !enablePIXAccountCreation(novoCliente) ? (
                      <span>
                        {" "}
                        * Preencha todos os campos obrigatórios antes de
                        solicitar a criação da conta MATERA
                      </span>
                    ) : flagDocuments ? (
                      <>
                        <span>
                          Acesse a aba DOCUMENTOS e anexe todos os documentos
                          antes de solicitar a abertura da conta
                        </span>
                      </>
                    ) : (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          type="submit"
                          className="left"
                          isCanceled
                          title="Solicitar Conta MATERA"
                          disabled={false}
                          loading={loadingInfoMatera}
                          onClick={() => createContaMatera()}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    {(formMatera[0] &&
                      formMatera[0].account_status === "ERROR") ||
                      (formMatera[0] &&
                        formMatera[0].account_status === "REJECTED") ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "20px",
                        }}
                      >
                        <TableGrid
                          columns={columnsPdvMatera}
                          data={formMatera}
                          pagination={false}
                          paginationPerPage={5}
                          loading={loadingInfoMatera}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <Button
                              type="submit"
                              className="left"
                              isCanceled
                              title="Reenviar Solicitação"
                              disabled={false}
                              loading={loadingInfoMatera}
                              onClick={() => revalidateAccountMatera()}
                            />
                          </div>
                          <p style={{ fontSize: "12px", textAlign: "center" }}>
                            Confira os dados de cadastro do Cliente e de seu
                            Representante e reenvie a solicitação
                          </p>
                        </div>
                      </div>
                    ) : (
                      <TableGrid
                        columns={columnsPdvMatera}
                        data={formMatera}
                        pagination={false}
                        paginationPerPage={5}
                        loading={loadingInfoMatera}
                      />
                    )}
                  </>
                )}
              </TabPanel>
              <TabPanel value="5">
                <div className="box">
                  <AvForm onSubmit={handleSubmitDocument}>
                    <div
                      className="row"
                      style={{ padding: "10px 10px 0px 10px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className="col-md-4"
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                          className="form-group"
                        >
                          <Select
                            id="selectTypes"
                            value={typeDocumentSelect}
                            onChange={setTypeDocumentSelect}
                            options={typeDocuments}
                            required
                          />

                          <AvField
                            type="file"
                            name="file"
                            value={selectedFile}
                            onChange={handleFileChange}
                            required
                          />
                          {selectedFileUpload !== null && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                              }}
                              className="col-md-12"
                            >
                              <button
                                style={{
                                  borderRadius: "8px",
                                }}
                                type="button"
                                onClick={handleClearClick}
                              >
                                <GrClearOption />
                              </button>
                            </div>
                          )}

                          <Button
                            type="submit"
                            title="Enviar"
                            disabled={
                              typeDocumentSelect.value === null ? true : false
                            }
                            loading={loading}
                          />
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <TableGrid
                            columns={columnsDocuments}
                            data={documents}
                            paginationPerPage={10}
                            pagination={false}
                            loading={loadingDocuments}
                          />
                        </div>
                      </div>
                    </div>
                  </AvForm>
                  {/* <TableGrid
                    columns={columnsDocuments}
                    data={documents}
                    paginationPerPage={10}
                    pagination={false}
                    loading={loadingDocuments}
                  /> */}
                </div>
              </TabPanel>
            </TabContext>
          </Box>
        </Content>
        <CustomModal
          id="modalKeysPixMatera"
          open={modalKeysPixMatera}
          close={handleCloseModalKeysPixMatera}
          modalRef={modalRefKeysPixMatera}
        >
          <Content>
            <CardHeader
              title={"CADASTRAR CHAVE PIX"}
              icon={"fa-unlock-alt"}
              searchVisible={false}
            />
            <AvForm onSubmit={handleSubmitKeyPix}>
              <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="selectTypes">Tipo: </label>
                    <Select
                      id="selectTypes"
                      value={typeSelect}
                      onChange={setTypeSelect}
                      options={optionsTypes}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.name}
                    />
                  </div>
                </div>
              </div>
              <CardFooter loading={loading}>
                <Button
                  type="submit"
                  title="Enviar"
                  disabled={false}
                  loading={loading}
                />
                <Button
                  type="button"
                  isCanceled
                  onClick={handleCloseModalKeysPixMatera}
                  title="Cancelar"
                  disabled={false}
                  loading={loading}
                />
              </CardFooter>
            </AvForm>
            <Content />
            <div style={{ width: "600px" }} />
            <TableGrid
              columns={columnsKeyPix}
              data={novoCliente ? novoCliente.keysPix : []}
              paginationPerPage={5}
              loading={loadingKeysPix}
            />
          </Content>
        </CustomModal>

        <CustomModal
          id="modalPDVs"
          open={modalPdvOpen}
          close={handleCloseModalPdv}
          modalRef={modalPdvRef}
        >
          <Content>
            <CardHeader
              title={"Adicionar PDV"}
              icon={"fa-unlock-alt"}
              searchVisible={false}
            />
            <AvForm
              onSubmit={(e, error) => handleSubmitPdv(e, error, "SHIPAY")}
            >
              <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                <div className="col-md-12">
                  <div className="form-group">
                    <AvField
                      type="text"
                      name="name"
                      label="Caixa"
                      placeholder="Caixa"
                      value={formPdv["name"] ? formPdv["name"] : ""}
                      required
                      onInput={(e) => handleFormPdv("name", e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <AvField
                      type="text"
                      name="key"
                      label="Account Id"
                      placeholder="Chave"
                      value={formPdv["account_id"] ? formPdv["account_id"] : ""}
                      required
                      onInput={(e) =>
                        handleFormPdv("account_id", e.target.value)
                      }
                    />
                  </div>
                </div>
                <CardFooter loading={loading}>
                  <Button
                    type="submit"
                    title="Enviar"
                    disabled={false}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    isCanceled
                    onClick={handleCloseModalPdv}
                    title="Cancelar"
                    disabled={false}
                    loading={loading}
                  />
                </CardFooter>
              </div>
            </AvForm>
          </Content>
        </CustomModal>

        <CustomModal
          id="modalStatements"
          open={modalStatementOpen}
          close={handleCloseModalStatement}
          modalRef={modalStatementRef}
        >
          <Content>
            <div >
              <div style={{ padding: "20px" }}>
                <AvForm onSubmit={handleChangeFilterDate}>
                  <div
                    style={{
                          display: "flex",
                          flexDirection: isDesktop ? "row" : "column",
                          justifyContent: isDesktop ? "space-around" : "flex-start",
                          gap: isDesktop ?  12 : 2,
                          padding: 10,
                      }}
                  >
                    <div style={{width : '100%'}} className="form-group">
                        {dataAtual && (
                          <AvField
                            type="date"
                            name="filterDate"
                            label="Inicio"
                            value={filterDateIni}
                            min={
                              filterDateFim
                                ? calcularDataMaxima(filterDateFim)
                                : ""
                            }
                            max={dayjs().format("YYYY-MM-DD")}
                            required
                            onChange={handleDataInicialChange}
                          />
                        )}
                      </div>
                    <div style={{width : '100%'}} className="form-group">
                        {dataAtual && (
                          <AvField
                            type="date"
                            required
                            name="filterDate"
                            label="Fim"
                            value={filterDateFim}
                            max={
                              filterDateIni
                                ? calcularDataMinima(filterDateIni)
                                : ""
                            }
                            onChange={handleDataFinalChange}
                          />
                        )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="button-export"
                        type="submit"
                        disabled={false}
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                </AvForm>
              </div>

              {loadingModalStatement ? (
                <div style={{ minWidth: "100%" }}>
                  <Loading
                    loading={loadingModalStatement}
                    margin={"20px"}
                    size={72}
                    color={"black"}
                  />
                </div>
              ) : (
                <MUIDataTable
                  title={"Extrato"}
                  data={statementMateraByClientFiltered}
                  columns={columnsMoviments}
                  options={options}
                />
              )}
            </div>
          </Content>
        </CustomModal>
      </EditProvider>
    </>
  );
};

export default ClienteNovo;
